/* Cart state is rendered by Liquid and replaced by Shrine on each cart update. */
(() => {
  if (window.lpCheckoutGuardInstalled) return;
  window.lpCheckoutGuardInstalled = true;
  const selector = '[data-lp-checkout-blocked="true"]';

  function prevent(event, button) {
    if (!button || !button.matches(selector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    button.disabled = true;
    const message = document.getElementById(button.getAttribute('aria-describedby'));
    if (message) message.focus({ preventScroll: true });
  }

  document.addEventListener('click', (event) => {
    prevent(event, event.target.closest('[data-lp-checkout-blocked]'));
  }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    prevent(event, Array.from(form.elements).find(el => el.name === 'checkout' && el.matches(selector)));
  }, true);

  // Theme quantity/T&C handlers must not re-enable an ineligible checkout.
  function enforce() {
    document.querySelectorAll(selector).forEach(button => {
      if (!button.disabled) button.disabled = true;
    });
  }
  new MutationObserver(enforce).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['disabled', 'data-lp-checkout-blocked'],
  });
  enforce();
})();
